import { useMemo, useState } from "react";
import { useHistory } from "react-router-dom";
// @material-ui/core components
import Link from "@material-ui/core/Link";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { FormProvider, useForm } from "react-hook-form";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";

import { useMediaQuery } from "@material-ui/core";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import NavigateBeforeIcon from "@material-ui/icons/NavigateBefore";

import componentStylesGeneric from "assets/theme/views/admin/generic.js";

import CardNotificationsDashboard from "components/Cards/Dashboard/CardNotificationsDashboard";
import { getNotificationsAction } from "redux/actions/notificationsAction";
import { PAGINATION } from "utils/const";
import FilterSection from "./NotificationsFilterSection";

const useStylesGeneric = makeStyles(componentStylesGeneric);

function Notifications() {
  const classes = useStylesGeneric();
  const theme = useTheme();
  const isSmDown = useMediaQuery(theme.breakpoints.down("sm"));
  const history = useHistory();
  const location = useLocation();

  const defaultFormValues = useMemo(
    () => ({
      search: "",
      origin: null, // Será preenchido pelo FilterSection quando o dataset carregar
      pageIndex: PAGINATION.FIRST_PAGE,
      pageSize: PAGINATION.PAGE_SIZE,
    }),
    []
  );

  const hasInitialSearchParams = (location.search || "") !== "";
  const [filtersReady, setFiltersReady] = useState(!hasInitialSearchParams);

  const form = useForm({
    mode: "onChange",
    defaultValues: defaultFormValues,
  });

  return (
    <Grid container classes={{ root: classes.containerRoot }}>
      <Grid
        item
        xs={12}
        md={12}
        style={{
          display: "flex",
          marginBottom: "37px",
          paddingRight: isSmDown ? "0.75rem" : "1.5rem",
          paddingLeft: isSmDown ? "0.75rem" : "1.5rem",
          alignItems: "center",
        }}
      >
        <Box
          component={Link}
          onClick={() => {history.goBack()}}
          className={classes.navigateBeforeBox}
          style={isSmDown ? { marginLeft: 4 } : undefined}
        >
          <NavigateBeforeIcon className={classes.navigateBefore} />
        </Box>
        <Box
          className={classes.pageTitle}
          data-testid="page-header-title"
          style={isSmDown ? { fontSize: "20px", lineHeight: "28px", marginLeft: "12px" } : undefined}
        >
          Voltar
        </Box>
      </Grid>
      <FormProvider {...form}>
        <Grid item xs={12} md={12}>
          <FilterSection
            defaultFormValues={defaultFormValues}
            filtersReady={filtersReady}
            setFiltersReady={setFiltersReady}
          />
        </Grid>

        <Grid item xs={12} md={12}>
          <CardNotificationsDashboard />
        </Grid>
      </FormProvider>
    </Grid>
  );
}

const mapStateToProps = (state) => ({ ...state });

const mapDispatchToProps = (dispatch) => ({
  getNotifications: () => dispatch(getNotificationsAction()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Notifications);
